<template>
	<vxe-modal v-model="showFlag" title="时/日/月/年流量统计"  show-zoom resize
						:destroy-on-close="true" fullscreen remember :esc-closable="true" :mask="false":lock-view="false">
		<a-layout  style="padding: 0;">
			<a-layout-sider   width="240" theme="light" class="mySider">
				<a-directory-tree multiple @select="onSelect" :selectedKeys="checkedMonitor"   :defaultSelectedKeys="checkedMonitor">
					<a-tree-node v-for="(item,index) in parentList" :key="item.value" :title="item.name" style="color: white;">
						<a-tree-node  v-for="(subItem,subIndex) in getSubTreeLeafNodeByParent(item.name,item.value)"
														:key="subItem.meterId"  :title="subItem.monitorName" is-leaf />
					</a-tree-node>
				</a-directory-tree>
			</a-layout-sider>
			<a-layout-content style="background-color: white;padding: 0.625rem;">
				<div class="actDiv">
					<label style="font-size: 0.8rem;">给水号：</label>
					<a-input style="width: 10.5rem;" v-model="theApid"  @change="apidChangeHandler"></a-input>
					<label style="font-size: 0.8rem;margin-left: 0.5rem;">类型：</label>
					
					<a-select style="width:6.5rem;  font-size: 0.6875rem;" v-model="theType"  allowClear
						@change="typeChange">
						<a-select-option v-for="(item,index) in typeList" :key="item.index" :value="item.index" >{{ item.name}}
						</a-select-option>
					</a-select>
					<label style="font-size: 0.8rem;margin-left: 0.625rem;">时间区间：</label>
					<a-date-picker  v-model="dateStart" style="margin-right: 0.5rem;width: 8rem;"
											:show-time="theType == 0 || theType == 1" :format="theFormatString" 
											@change="beginDateChangeHandler"/>
					<label >至</label>
					<a-date-picker v-model="dateEnd"  style="margin-left: 0.5rem;width: 8rem;"
									:show-time="theType == 0 || theType == 1" :format="theFormatString"
									@change="endDateChangeHandler"/>
					<label style="font-size: 0.8rem;margin-left: 0.625rem;" v-show="showHourFlag">时段：</label>
					<a-select v-model="beginHour" style="margin-left: 0.5rem;width: 5rem;" v-show="showHourFlag">
						<a-select-option v-for="item in hourList" :key="item.index" :value="item.index">
							{{item.name}}
						</a-select-option>
					</a-select>
					<label style="font-size: 0.8rem;margin-left: 0.625rem;" v-show="showHourFlag">至</label>
					<a-select v-model="endHour"  style="margin-left: 0.5rem;width: 5rem;" v-show="showHourFlag">
						<a-select-option v-for="item in hourList" :key="item.index" :value="item.index">
							{{item.name}}
						</a-select-option>
					</a-select>
					<a-button size="small"   icon="search" @click="doQuery" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
					<a-button  size="small"   @click="doExport"  icon="cloud-download" :loading="exportLoading">导出</a-button>
				</div>
				<a-tabs type="card">
					<a-tab-pane key="1" tab="抄收报表">
						<a-table  size="small" :columns="columns" :data-source="statisList" bordered :loading="loading"
										rowKey="id" :pagination="false" :scroll="{y:500}" :hideOnSinglePage="false">
						</a-table>
					</a-tab-pane>
					<a-tab-pane key="2" tab="曲线分析图" :forceRender="true">
						<ve-line :data="statisData"  :settings="chartSettings" :extend="chartExtend" 
						:legend="{ bottom: '0' }" :title="{text:statisTitle,x:'center',y:'top'}" :grid={left:60,right:60}
						 judge-width  height="500px"/>
					</a-tab-pane>
				</a-tabs>
			</a-layout-content>
		</a-layout>	
	</vxe-modal>
</template>

<script>
	const columns = [
		{
			title: '给水号',
			dataIndex: 'apId',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表地址',
			dataIndex: 'meterAddr',
			width:140,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表读数',
			dataIndex: 'readData',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '间隔流量',
			dataIndex: 'intervalFlow',
			width:100,
			className:'v-cell',
			align:'center',
		},
		{
			title: '上传时间',
			dataIndex: 'readTime',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
	];
	export default {
		data(){
			return {
				beginHour:0,
				endHour:2,
				showHourFlag:true,
				theType:0,
				exportLoading:false,
				theApid:"",
				columns,
				theFormatString:"YYYY-MM-DD HH:mm:ss",
				loading:false,
				showFlag:false,
				checkedMonitor:[],
				usedBegin:null,
				usedEnd:null,
				dateStart:null,
				dateEnd:null,
				dataList:[],
				typeList:[
					{
						name:"5分钟",
						index:1
					},
					{
						name:"时流量",
						index:0
					},
					{
						name:"日流量",
						index:2
					},
					{
						name:"月流量",
						index:3
					},
					{
						name:"年流量",
						index:4
					},
				],
				statisList:[],
				statisData:{},
				chartSettings:{
					area: false, 
					yAxisName: ['间隔流量'],
					labelMap: {
						intervalFlow: '流量',
					  },
				},
				parentList:[],
			}
		},
		methods:{
			getSubTreeLeafNodeByParent(parentName,parentKey){
				let temp = [];
				if(parentKey == 0){
					temp = this.Config.deepClone(this.dataList);
				}else{
					let a = parentName.split("(");
					for (var i = 0; i < this.dataList.length; i++) {
						let item =  this.dataList[i];
						if(item.groupName == a[0]){
							temp.push(item);
						}
					}
				}
				return temp;
			},
			createParentList(){
				let titleList = ["监控点"];
				this.dataList.forEach((item)=>{
					if(titleList.indexOf(item.groupName) ==-1){
						titleList.push(item.groupName);
					}
				});
				for (var i = 0; i < titleList.length; i++) {
					let name = titleList[i];
					let array = this.getSubTreeLeafNodeByParent(name,i);
					let title = name+"("+array.length+")";
					let item = {name:title,value:i};
					this.parentList.push(item);
				}
			},
			apidChangeHandler(e){
				let v = e.target.value;
				if(v.length>=10){
					let a= this.getMarkerByApid(v);
					if(a!=null){
						let meterId = a.meterId;
						this.checkedMonitor=[meterId];
					}else{
						this.checkedMonitor=[];
					}
				}else{
					this.checkedMonitor=[];
				}
			},
			getMarkerByApid(apid){
				let result = null;	
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(item.meterApid == apid){
						result = item;
						break;
					}
				}
				return result;
			},
			beginDateChangeHandler(date,dateString){
				this.dateStart = this.$moment(dateString).format(this.theFormatString);
			},
			endDateChangeHandler(date,dateString){
				this.dateEnd = this.$moment(dateString).format(this.theFormatString);
			},
			configType(type){
				switch(type){
					//日报表
					case 0:{
						this.theFormatString = "YYYY-MM-DD HH:mm:ss";
						this.showHourFlag = true;
					}
					//5分钟
					break;
					case 1:{
						this.theFormatString = "YYYY-MM-DD HH:mm:ss";
						this.showHourFlag = false;
					}
					break;
					case 2:{
						this.theFormatString = "YYYY-MM-DD";
						this.showHourFlag = false;
					}
					break;
					case 3:{
						this.theFormatString = "YYYY-MM";
						this.showHourFlag = false;
					}
					break;
					case 4:{
						this.theFormatString = "YYYY";
						this.showHourFlag = false;
					}
					break;
				}
			},
			showView(meterIdList,type,dStart,dEnd){
				this.theType  = type;
				this.configType(type);
				this.showFlag = true;
				this.checkedMonitor = meterIdList;
				if(dStart!=null){
					this.dateStart = dStart;
				}
				if(dEnd!=null){
					this.dateEnd = dEnd;
				}
				if(this.checkedMonitor.length){
					let item = this.getTheCheckMonitor();
					if(item != null){
						this.theApid = item.meterApid;
					}
					this.doQuery();
				}
			},
			typeChange:function(){
				this.configType(this.theType);
				this.dateStart = this.$moment().format(this.theFormatString);
				this.dateEnd = this.$moment().format(this.theFormatString);
			},
			getMeterMonitorList4Map(){
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_MAP_INFO_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
						this.createParentList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			onSelect(keys, event){
				this.checkedMonitor = keys;
				let item = this.getTheCheckMonitor();
				if(item != null){
					this.theApid = item.meterApid;
				}
			},
			doQuery(){
				if(this.doValid()){
					this.loading = true;
					let url = this.Api.getLastUrl(this.Api.METER_MONITOR_FLOW_STATIS_URL);
					let param = {
						meterId:this.checkedMonitor[0],
						beginTime:this.dateStart,
						endTime:this.dateEnd,
						type:this.theType,
						beginHour:this.beginHour,
						endHour:this.endHour
					};
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.loading = false;
						let code = data.data.code;
						let result = data.data.result;
						let msg = data.data.message;
						if(code == this.Api.HTTP_OK_CODE){
							this.filterResult(result);
							this.drawEcharts();
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.loading = false;
						console.log(error);
					});
				}
			},
			filterResult(list){
				this.statisList = [];
				if(this.usedBegin == null || this.usedEnd == null){
					this.statisList = list;
				}else{
					for(var i=0;i<list.length;i++){
						let item = list[i];
						if(item.intervalFlow>=this.usedBegin && item.intervalFlow<=this.usedEnd){
							this.statisList.push(item);
						}
					}
				}
			},
			doValid(){
				if(!this.checkedMonitor.length){
					this.$message.error('监控点不能为空');
					return false;
				}
				if(this.dateStart == null || this.dateEnd == null){
					this.$message.error('开始日期和截止日期不能为空');
					return false;
				}
				if((this.theType==0||this.theType ==1 ) && (this.beginHour >=  this.endHour)){
					this.$message.error("开始时段不能大于等于结束时段");
					return false;
				}
				let tp;
				switch(this.theType){
					case 0:{
						tp = 'seconds';
					}
					break;
					case 1:{
						tp = 'seconds';
					}
					break;
					case 2:{
						tp = 'days';
					}
					break;
					case 3:{
						tp = 'months';
					}
					break;
					case 4:{
						tp = 'years';
					}
					break;
				}
				const diff = this.$moment(this.dateEnd).diff(this.$moment(this.dateStart),tp);
				if (diff<0){
					this.$message.error('开始日期不能大于截止日期');
					return false;
				}else{
					return true;
				}
			},
			doExport(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_FLOW_STATIS_EXPORT_URL);
				let param = {
					meterId:this.checkedMonitor[0],
					beginTime:this.dateStart,
					endTime:this.dateEnd,
					type:this.theType,
					beginHour:this.beginHour,
					endHour:this.endHour
				};
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = this.monitorName+'-日/月/年流量统计报表'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			drawEcharts(){
				var rows = [];
				for(var i =0 ;i<this.statisList.length;i++){
					var item = this.statisList[i];
					var obj = {
						"readTime":item.readTime,
						"intervalFlow":item.intervalFlow,
					}
					rows.push(obj);
				}
				var statisData = {
					columns: ['readTime','intervalFlow'],
					rows:rows.reverse(),
				}
				this.statisData = statisData;
			},
			getTheCheckMonitor(){
				var result = null;
				let checkedMeter = this.checkedMonitor[0];
				for(var i=0;i<this.dataList.length;i++){
					let item = this.dataList[i];
					if(checkedMeter == item.meterId){
						result = item;
						break;
					}
				}
				return  result;
			},
		},
		created() {
			this.getMeterMonitorList4Map();
		},
		computed:{
			myTitle:function(){
				let a = this.dataList.length;
				return "监控表("+a+")";
			},
			monitorName:function(){
				let item = this.getTheCheckMonitor();
				if(item == null){
					return "";
				}else{
					return item.monitorName;
				}
			},
			statisTitle:function(){
				return "间隔流量曲线("+this.monitorName+")";
			},
			chartExtend:function(){
				var rotate = 0;
				if(this.statisList.length>12){
					rotate =  50;
				}
				let  a = {
					series:{
						smooth:true,
						type:'line',
					},
					xAxis: {
						axisLabel: {
							interval: 0,
							rotate: rotate
						}
					},
				};
				return a;
				
			},
			hourList() {
				return [
					{
						name:'0时',
						index:0,
					},
					{
						name:'1时',
						index:1,
					},
					{
						name:'2时',
						index:2,
					},
					{
						name:'3时',
						index:3,
					},
					{
						name:'4时',
						index:4,
					},
					{
						name:'5时',
						index:5,
					},
					{
						name:'6时',
						index:6,
					},
				];
			}
		}
	}
</script>
<style>
	.mySider{
		height: calc(100vh - 70px);
		overflow-y: scroll;
		overflow-x: hidden;
	}
</style>
